import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement);

class ChartInterestRate extends React.Component {
    constructor(props) {
        super(props);
        this.chartRef = {};

        this.chartPaymentData = {
            labels: [],
            datasets: [
              {
                label: 'Flex',
                data: [],
                borderWidth: 2,
                backgroundColor: '#B13950',
                fill: true,
                borderColor: '#B13950',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true
                
              },
              {
                label: 'Advantage',
                data: [],
                borderWidth: 2,
                backgroundColor: '#4289AF',
                borderColor: '#4289AF',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true
              }
              
            ],
          };
        this.chartPaymentOptions = {
            responsive: true,
            plugins: {
              legend: {
                position: 'top'
              },
              tooltip: {
                callbacks: {
                  title: function(context) {
                    return 'Year: ' + context[0].label;
                  },
                  label: function(context) {
                      return context.dataset.label + ': ' + context.parsed.y +  '%';
                  }
              }
              }
            },
            scales: {
              x:{
                ticks: {
                  callback: function(tick, index, array) {
                    if (index % 5){
                      if(index === 1){
                        return tick + " Year";
                      }
                      else{
                        return "";
                      }
                    }
                    else{
                      if(index === 0){
                        return "";
                      }
                        else{
                          return tick + " Years";
                        }
                      
                    }
                  }
                }
              },
              y: {
                ticks: {
                  // forces step size to be 50 units
                  stepSize: 1,
                  callback: function(tick, index, array) {
                    return tick + "%";
                  }
                }
              }
            }
        }
        
    }

    componentDidMount() {
        this.buildData();
    }

    buildData(){
        this.chartPaymentData.labels = [];
        this.chartPaymentData.datasets[0].data = [];
        this.chartPaymentData.datasets[1].data = [];
        if(this.props.competitorDisplay && this.props.competitorHasCalculation){
          this.chartPaymentData.datasets[2] = {
            label: 'Competitor',
            data: [],
            borderWidth: 2,
            backgroundColor: '#808080',
            borderColor: '#808080',
            pointBorderWidth: 0,
            pointRadius: 1,
            stepped: true
          }
        }
        else{
          if(this.chartPaymentData.datasets[2] !== undefined){
            this.chartPaymentData.datasets.pop();
          }
        }
        
        for(var a=0; a< this.props.term; a++){
            this.chartPaymentData.labels.push(a);
            
            if(a < 5){
                this.chartPaymentData.datasets[1].data.push(this.props.calcData.advantageAmortised.interestRateFirst5Years);
                this.chartPaymentData.datasets[0].data.push(this.props.calcData.flexAmortised.interestRateFirst5Years);
            }
            else{
                this.chartPaymentData.datasets[1].data.push(this.props.calcData.advantageAmortised.interestRateAfter5Years);
                this.chartPaymentData.datasets[0].data.push(this.props.calcData.flexAmortised.interestRateAfter5Years);
            }
            if(this.props.competitorDisplay && this.props.competitorHasCalculation){
              if(a < this.props.competitorCommitmentPeriod){
                this.chartPaymentData.datasets[2].data.push(this.props.calcDataCompetitor.interestRateInitialPeriod);
              }
              else{
                this.chartPaymentData.datasets[2].data.push(this.props.calcDataCompetitor.interestRateExtendedPeriod);
              }
            }

        }
    }

    componentDidUpdate(prevProps) {
        this.buildData();
        this.chartRef.data.labels = this.chartPaymentData.labels;
        this.chartRef.data.datasets = this.chartPaymentData.datasets;
        this.chartRef.update();
    }
    

  render() {
        return (<div className='mortgage-calculator__monthly-payment'>
            <h2>Interest Rate</h2>
            <Line ref = {(reference) => this.chartRef = reference} options={this.chartPaymentOptions} data={this.chartPaymentData} />
        </div>);
  }

  
}

export default ChartInterestRate;